import React from 'react'
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const ProdSearchGridProcessData = ({formObject, viewData, viewRow, rowKey}) => {

    // console.log("xygrid process data", viewData, viewRow);
    // const value = 75;

    // const isDelay = value > 100 ? true : false;

    const getStyle = () => {
        if (viewRow.rowValues.taskStatus.dataList 
                && viewRow.rowValues.taskStatus.dataList.colCssStyle 
                && viewRow.rowValues.taskStatus.dataList.colCssStyle !== "") {
            return JSON.parse(viewRow.rowValues.taskStatus.dataList.colCssStyle)
        }
        else {
            return {}
        }
    }

    return (
        <div class="uiProdGridProcessContainer">
            <div class="uiTitle">
                {viewRow.rowValues.taskTitle.valF}
            </div>
            <div class="">
                <span className="uiBold"><SarasTrans value="Iss" /></span>
                <span className="uiSpacerH5">{viewRow.rowValues.taskIssuedOn.val}</span>
                <span className="uiBold"><SarasTrans value="Ret" /></span>
                <span className="uiSpacerH5">{viewRow.rowValues.taskReturnedOn.val}</span>
            </div>
            <div class="">
                <span style={getStyle()} className="uiChip">{viewRow.rowValues.taskStatus.valF}</span>
                <span className="uiSpacerH5 uiBold"><SarasTrans value="Hrs" /></span>
                <span className="uiSpacerH5">{viewRow.rowValues.taskEstTime.valF}</span>
                <span> / </span>
                <span className="uiSpacerH5">{viewRow.rowValues.taskActTime.valF}</span>
                {/* <SarasProgress value={viewRow.rowValues.percentComplete.val} progressType="bar"
                    progressClass={isDelay? "secondary" : "primary"} 
                    labelClass="uiUnHighlight uiGrey"
                /> */}

                {/* <span className="uiUnHighlight uiBlue uiComfortText">{viewRow.rowValues.taskStatus.valF}</span> */}
            </div>
        </div>
    );
}

export default ProdSearchGridProcessData
